<template>
  <div class="page">
    <div class="page-content">
      <div class="user-label">{{ this.salespersonName }}您好，请选择一家客户</div>
      <div class="search-container">
        <div class="search-input">
          <input
            v-model="keyword"
            type="text"
            placeholder="药店名称/药店ID"
            maxlength="50"
          />
          <i class="search-icon"></i>
        </div>
        <div class="search-button" @click="onSearch">搜索</div>
      </div>
      <div class="sub-title">搜索结果</div>
      <div class="list-empty" v-if="!data.length">
        <img :src="require('@/assets/img/shop-empty.png')" class="icon-empty" />
        <div class="empty-desc">
          未找到该药店，有以下可能：该药店名称或ID填写错误、该药店不在您的私海中或者该药店还没有开通商城。
        </div>
      </div>
      <div class="pharmacy-list" v-else>
        <div class="pharmacy-item" v-for="(item, index) in data" :key="index" @click="selectPharmacy(item.crmStoreId)">
          <div class="pharmacy-item-title">{{ item.customerName }}</div>
          <div class="pharmacy-item-id">药店ID：{{ item.crmStoreId }}</div>
        </div>
        <div class="pagination-container">
          <el-pagination
            :current-page.sync="currentPage"
            @current-change="onSearch"
            layout="total, prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainFooter from '@/components/MainFooter/index.vue';
import * as api from '@/services'
export default {
  name: 'SelectPharmacy',
  components: {
    MainFooter
  },
  computed: {
    token() {
      return this.$route.params.token;
    },
  },
  data() {
    return {
      keyword: '',
      pageSize: 20, // 固定6条数据
      currentPage: 1,
      total: 0,
      data: [],
      salespersonName: ''
    }
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    async onSearch() {
      if (this.keyword.length === 1) {
        this.$message.error('请输入至少两个字')
        return
      }
      const res = await api.crm.querySalespersonCustomerList({
        keyword: this.keyword,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ecIdShareToken: this.token === '-1' ? null : this.token
      })
      this.data = res?.list || []
      this.total = res.totalRecord
      this.salespersonName = res.salespersonName
    },
    async selectPharmacy(crmCompanyId) {
      // 设置cookie
      await api.crm.chooseOrderingBehalfOfCustomer({
        crmStoreId: crmCompanyId,
        ecIdShareToken: this.token === '-1' ? null : this.token
      })
      this.$router.replace('/mallHomePage/all');
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
}
.page-content {
  width: 1232px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .user-label {
    font-size: 24px;
    line-height: 24px;
    font-weight: 500;
    color: #262626;
    margin-top: 36px;
  }
  .search-container {
    width: 640px;
    border: 2px solid #1e8dff;
    display: flex;
    position: relative;
    margin-top: 22px;
    .search-input {
      input {
        width: 516px;
        height: 38px;
        outline: none;
        border: none;
        padding: 0 37px;
      }
    }
    .search-button {
      width: 100%;
      height: 38px;
      border: 2px solid #1e8dff;
      background: #1f8fff;
      color: #fff;
      cursor: pointer;
      text-align: center;
      font-size: 16px;
      line-height: 36px;
    }
    .search-icon {
      width: 14px;
      height: 14px;
      background: url(../../assets/img/search-icon.png) 0 0 no-repeat;
      position: absolute;
      pointer-events: none;
      top: 12px;
      left: 18px;
      background-size: 100%;
      z-index: 1;
    }
  }
  .sub-title {
    width: 100%;
    margin-top: 44px;
    background: #f5f5f5;
    border: 1px solid #eeeeee;
    padding: 9px;
    color: #595959;
    font-size: 12px;
  }
  .pharmacy-list {
    width: 100%;
    height: 720px;
    .pharmacy-item {
      margin-top: 24px;
      padding: 24px;
      border: 1px solid #eeeeee;
      width: 100%;
      cursor: pointer;
      .pharmacy-item-title {
        font-size: 24px;
        line-height: 24px;
        font-weight: 500;
        color: #262626;
        margin-bottom: 8px;
      }
      .pharmacy-item-id {
        font-size: 14px;
        line-height: 14px;
        color: #595959;
      }
    }
    .pagination-container {
      margin-top: 24px;
      display: flex;
      justify-content: flex-end;
    }
  }
  .list-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      margin-top: 80px;
      width: 220px;
      height: 220px;
    }
    .empty-desc {
      color: #8c8c8c;
      font-size: 14px;
      margin-top: 8px;
    }
  }
}
</style>
